<template>
  <v-card flat class="px-6">
    <p v-html="$t('scenarioExport.exportDescription')">
    </p>
    <p v-html="$t('scenarioExport.exportExtender')">
    </p>
    <v-btn color="primary" @click="" :href="csvUrl">
      <v-icon left>mdi-download</v-icon>
      {{ $t('common.download') }}
    </v-btn>

    <template v-if="institutionIsConsortium && institutionIsJisc">
      <div class="mt-10 text-h5">
         {{ $t('scenarioExport.memberSubRequests') }}
      </div>
      <p>
        {{ $t('scenarioExport.memberSubRequestsDesc') }}
      </p>

      <v-btn
        :loading="isLoading"
        @click="sendSubRequestsEmail"
        color="primary"
      >
        <v-icon left v-if="subRequestsText.includes('Download')">mdi-download</v-icon>
        {{ subRequestsText }}
      </v-btn>

    </template>


  </v-card>


</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {urlBase, api} from "../../api";


export default {
  name: "ScenarioExportTab",
  components: {},
  props: {
    myRole: String,
    isConsortialFeeder: Boolean,
    publishers: Array,
  },
  data() {
    return {
      dialogs: {
        createGroupMember: false,
      },
      isLoading: false,
      subRequestsText: this.$t('scenarioExport.downloadViaEmail')
    }
  },
  methods: {
    ...mapMutations([
      "snackbar",
    ]),
    async sendSubRequestsEmail() {
        console.log("send the sub requests email")
        this.subRequestsText = this.$t('scenarioExport.youllGetEmail')
        const postData = {email: this.userEmail}
        this.isLoading = true
        try {
            api.post(this.memberSubscriptionRequestsCsvUrl, postData)
        }
        catch(e) {
            if (e.response.status === 404) {
                this.errorMsg = this.$t('login.accountNotFound')
                return
            }
            else {
                this.errorMsg = this.$t('common.somethingWentWrong')
            }
        }
        finally {
            this.isLoading = false
        }
        this.requestState = "success"
    },
  },
  computed: {
    ...mapGetters([
      'institutionId',
      'institutionName',
      'institutionIsDemo',
      "institutionIsConsortium",
      "institutionUsersWithRoles",
      "institutionIsJisc",
      'userConsortia',
      'userInstitutions',
      'userEmail',
    ]),
    csvUrl() {
      let scenarioId = this.$store.getters.scenarioId
      let url = `${urlBase}scenario/${scenarioId}/export.csv`; // urlBase ends with a slash
      url += "?timestamp=" + `${new Date().getTime()}`
      url += "&jwt=" + localStorage.getItem("token")
      return url
    },
    memberSubscriptionRequestsCsvUrl() {
      let scenarioId = this.$store.getters.scenarioId
      let url = `scenario/${scenarioId}/member-institutions/consortial-scenarios.csv`;
      url += "?timestamp=" + `${new Date().getTime()}`
      url += "&jwt=" + localStorage.getItem("token")
      return url
    },
  },
  created() {
  },
  mounted() {
  },
  watch: {
    "foo": {
      immediate: true,
      handler: function (to, from) {
      }
    }
  }
}
</script>

<style lang="scss">


</style>
